/* src/courses/selectors.js */

import { createSelector } from 'reselect';
import { map, isEmpty, forEach } from 'lodash';

import { createPageSelector } from '../../util';
import { loadTexts } from '../../config/texts';

export const getCourses = createSelector(
  state => state.courses.main.data,
  state => state.appState.locale,
  (courses, locale) => map(courses, course => {
    const texts = loadTexts('courses', locale);
    const { fields } = texts;
    const {
      subject,
      number,
      university,
      availableTutors,
      nonAvailableTutors,
      title,
      _id,
      active,
      availableTutorsCount,
      tutorsOnBoarded,
      totalLessonsBooked,
      currentLessonsBooked,
      requestsByStudentsCount,
    } = course;
    const result = {
      _id,
      [fields.course_code]: `${subject} ${number}`,
      [fields.institution]: university.name,
      _color: (availableTutors && availableTutors.length > 0) ? 'green' : '',
      _active: active,
      [fields.title]: title,
      [fields.completed]: totalLessonsBooked,
      [fields.upcoming]: currentLessonsBooked,
      [fields.available]: `${availableTutors.length} / ${availableTutors.length + nonAvailableTutors.length}`,
      [fields.course_requests]: requestsByStudentsCount,
    };
    return result
  })
);

export const getRequestedCourses = createSelector(
  state => state.courses.main.data,
  state => state.appState.locale,
  (courses, locale) => {
    const texts = loadTexts('courses', locale);
    const { fields } = texts;
    let requestArray = [];
    forEach(courses, course => {
      const { studentsRequesting } = course;
      if (!isEmpty(studentsRequesting)) {
        forEach(studentsRequesting, s => {
          let student = {
            _id: s._id,
            [fields.course]: `${course.subject} ${course.number}`,
            [fields.requested_by]: `${s.user.first} ${s.user.last}`,
            [fields.email]: s.user.email
          };
          requestArray.push(student)
        });
      };
    });
    return requestArray;
  }
);


export const fetchCoursesState = createSelector(
  state => state.courses.main,
  ({ loading, error }) => ({ loading, error })
);

export const getCoursesListRange = createSelector(
  state => state.courses.browse,
  ({ start, end, count }) => ({ start, end, count })
);

export const getSelected = createSelector(
  state => state.courses.selected.course,
  course => {
    const { title, subject, number, _university, _id } = course;
    return {
      title,
      subject,
      number,
      _university,
      _id,
    };
  }
);

export const getCoursesWithTutors = createSelector(
  state => state.courses.main.data,
  state => state.appState.locale,
  (courses, locale) => map(courses, course => {
    const texts = loadTexts('courses', locale);
    const { fields } = texts;
    const {
      subject,
      number,
      university,
      availableTutors,
      nonAvailableTutors,
      title,
      _id,
      active,
      availableTutorsCount,
      tutorsOnBoarded,
      totalLessonsBooked,
      currentLessonsBooked,
      requestsByStudentsCount,
    } = course;
    const result = {
      _id,
      [fields.course_code]: `${subject} ${number}`,
      [fields.institution]: university.name,
      _color: (availableTutors && availableTutors.length > 0) ? 'green' : '',
      _active: active,
      [fields.title]: title,
      [fields.completed]: totalLessonsBooked,
      [fields.upcoming]: currentLessonsBooked,
      [fields.available]: `${availableTutors.length} / ${availableTutors.length + nonAvailableTutors.length}`,
      [fields.course_requests]: requestsByStudentsCount,
      availableTutors,
      nonAvailableTutors
    };
    return result
  })
);

export const fetchCourseState = createSelector(
  state => state.courses.main,
  ({ loading, error }) => ({ loading, error })
);

export const getPageInfo = createPageSelector('courses');



// WEBPACK FOOTER //
// ./src/modules/courses/selectors.js